import * as Slider from "@radix-ui/react-slider";

export type ProgressBarProps = {
  currentTimeMs: number;
  durationMs: number;
  onSeek: (progress: number) => void;
};

export default function ProgressBar({
  currentTimeMs,
  durationMs,
  onSeek,
}: ProgressBarProps) {
  const progress = durationMs > 0 ? (currentTimeMs / durationMs) * 100 : 0;

  const handleValueChange = (values: number[]) => {
    const value = values.at(0);
    if (typeof value !== "number") return;
    onSeek(value / 100);
  };

  return (
    <Slider.Root
      value={[progress]}
      onValueChange={handleValueChange}
      min={0}
      max={100}
      step={0.1}
      aria-label="Seek through track"
      aria-valuetext={`${Math.round(progress)}%`}
      className="relative flex flex-1 touch-none items-center cursor-pointer"
    >
      <Slider.Track className="relative h-1 w-full rounded-full bg-[#6A6E80] cursor-pointer">
        <Slider.Range className="absolute h-full rounded-full bg-[#43DDA7]" />
      </Slider.Track>
      <Slider.Thumb className="block h-3 w-3 rounded-full bg-white shadow-[0_0_0_2px_rgba(0,0,0,0.35)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#43DDA7] focus-visible:ring-offset-2 focus-visible:ring-offset-[#050506]" />
    </Slider.Root>
  );
}
